import { useState } from 'react';

export default function TextFooter({ text, has_background = false }) {
  const [isExpanded, setIsExpanded] = useState(true);
  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

    if (!text) return null;
    return (
        <div className={has_background ? 'c-text_footer' : 'c-text_footer_no_background'}>
            <div className='c-text_footer__container' style={{maxHeight: isExpanded ? 'fit-content' : '324px'}}>
                <div className='c-text_footer__container_content' dangerouslySetInnerHTML={{ __html: text }} style={{maxHeight: isExpanded ? 'fit-content' : '233px'}}></div>
                <div className='c-text_footer__container_button' onClick={toggleExpand}>
                {/* {isExpanded ? (
                    <a>Thu gọn<img src='/assets/img/collapse.svg' style={{width: '16px', height: '16px'}}/></a>
                ) : (
                    <a>Xem thêm<img src='/assets/img/expand.svg' style={{width: '16px', height: '16px'}}/></a>
                )} */}
                </div>
            </div>
        </div>
    );
}